import ProductMention from "./ProductMention";

import "./ProductMention.scss";

export * from "./ProductMention.types";

export { ProductMention };
